import React from "react";
import { useSingleHardware } from "../../hooks/useHardware";
import { Hardware } from "../../types/hardware.types";
import { dateConverter } from "../../../../utils/dateConverter";
import { limitString } from "../../../../utils/string.utils";

export function HardwareDevUid({ hardwareId }: { hardwareId?: string }) {
  const {
    singleQuery: { data, isLoading, isError },
  } = useSingleHardware(hardwareId);
  if (isError) return <></>;
  if (isLoading) return <>...</>;
  if (!data) return <></>;
  return <>{data.hardware_device_id}</>;
}

export interface HardwareInfoProps {
  info: keyof Hardware;
  id?: string;
  styles?: boolean;
  emptyText?: string;
  limitText?: number;
  renderComponent?: (config: {
    labelRender: React.ReactNode;
    goTo: () => void;
  }) => JSX.Element;
}
export function HardwareInfo({
  info,
  id,
  emptyText,
  limitText,
}: HardwareInfoProps) {
  const {
    singleQuery: { data, isLoading, isError },
  } = useSingleHardware(id);

  const convertValue = (info: keyof Hardware, value: any) => {
    switch (info) {
      case "hardware_created_at":
        return dateConverter(value);
      case "hardware_updated_at":
        return dateConverter(value);
      default:
        return value;
    }
  };

  if (isError) return <>{emptyText}</>;
  if (isLoading) return <>...</>;
  if (!data) return <>{emptyText}</>;
  return <>{limitString(convertValue(info, data[info]), limitText)}</>;
}
